import { Box, styled } from '@mui/material'
import { ReactNode } from 'react'

const InfoBox = styled(Box)({
  marginTop: 5,
  marginLeft: 5,
  paddingLeft: 10,
  paddingRight: 10,
  borderRadius: 'var(--dewi_radius_rounded)',
  display: 'block',
})

type CardInfoBoxProps = {
  children: ReactNode
  color: string
}

/**
 * Both chips used to carry a hue (green for listed, grey for staked). They are
 * the same translucent pill now; the word is what tells them apart.
 */
function getCardColor(color: string) {
  if (color === 'listed' || color === 'staked') return 'rgba(0, 0, 0, 0.72)'
  return color
}

function CardInfoBox({ children, color }: CardInfoBoxProps) {
  return (
    <InfoBox sx={{ backgroundColor: color && getCardColor(color) }}>
      {children}
    </InfoBox>
  )
}

export default CardInfoBox
